<template>
  <div class="w-full" v-if="approvers.length > 0">
    <div class="flex justify-start items-center w-full text-sm px-1 mb-1">
      <span class="flex justify-center items-center">
       {{ $t(title) }}:
      </span>
      <div class="flex justify-center items-center -space-x-2.5 relative ml-2">
        <ui-pictogram 
          v-for="(approver, i) in slicedApprovers"
          :key="i"
          :user="approver.user"
          class="graphPictogram"
        />
        <!-- rest approvers -->
        <ui-pictogram
          v-if="approvers.length > approversLimit"
          :force-title="'+' + (approvers.length - approversLimit)"
          :force-content="'+' + (approvers.length - approversLimit)"
        />
      </div>
    </div>
    <div
      class="h-2 rounded-full"
      :class="graphClass"
      :style="graphWidth"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    graphClass: String,
    total: Number,
    approvers: {
      type: Array,
      default: function(){
        return []
      },
    },
    approversLimit: {
      type: Number,
      default: 5
    }
  },
  computed: {
    graphWidth() {
      return {
        'width': 100 / this.total * this.approvers.length + '%',
      }
    },
    slicedApprovers() {
      return this.approvers.slice(0, this.approversLimit)
    },
  }
}
</script>
